const isEmptyString = (s: any) => s == null || ['', 'null', 'undefined'].includes(s)

export const valueAs = {
  stringOrNull: (val: any) => (isEmptyString(val) ? null : val),
  boolean: (val: any) => val === 'true',
  booleanOrNull: (val: any) => (['true', 'false'].includes(val) ? val === 'true' : null),
  numberOrNull: (val: any) => {
    if (isEmptyString(val)) return null
    return isNaN(+val) ? null : +val
  },
  number: (val: string) => valueAs.numberOrNull(val) ?? 0,
}

export const toValue = {
  phone: (val?: Maybe<string>) =>
    val?.replace(/^(02|0\d{2}|\d{3,4})(\d{1,4})?(\d{4,}).*/, '$1-$2-$3').replace(/-{2}/, '-') ?? '',
  virtualPhone: (val?: Maybe<string>) =>
    val?.replace(/^(050|050\d)(\d{3,4})(\d{4})$/, `$1-$2-$3`) ?? '',
  birth: (val?: Maybe<string>) =>
    val?.replace(/^(\d{4})(\d{1,2})?(\d{2}).*/, '$1-$2-$3').replace(/-{2}/, '-') ?? '',
  card: (val?: Maybe<string>) => val?.replace(/\B(?=(\d{4})+(?!\d))/g, '-') ?? '',
}
